"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventProperty = exports.EventName = void 0;
var EventName;
(function (EventName) {
    EventName["PRODUCT_ELIMINATED_FROM_CART_START"] = "Product Eliminated from Cart Start";
    EventName["PRODUCT_ELIMINATED_FROM_CART_CANCELED"] = "Product Eliminated from Cart Canceled";
    EventName["PRODUCT_ELIMINATED_FROM_CART_COMPLETED"] = "Product Eliminated from Cart Completed";
    EventName["PRODUCT_ADDED"] = "Product Added";
    EventName["PRODUCT_REMOVED"] = "Product Removed";
    EventName["PRODUCT_VIEWED"] = "Product Viewed";
    EventName["PRODUCT_QUANTITY_CHANGED"] = "Product Quantity Changed";
    EventName["SEARCH_STARTED"] = "Search Started";
    EventName["PRODUCTS_SEARCHED"] = "Products Searched";
    EventName["RESET_CART_START"] = "Reset Cart Start";
    EventName["RESET_CART_CANCELED"] = "Reset Cart Canceled";
    EventName["RESET_CART_COMPLETED"] = "Reset Cart Complete";
    EventName["CART_VIEWED"] = "Cart Viewed";
    EventName["CART_SAVED"] = "Cart Saved";
    EventName["ORDER_SENT"] = "Order Sent";
    EventName["STOREFRONT_VISITED"] = "Storefront Visited";
    EventName["CATEGORY_SELECTED"] = "Category Selected";
})(EventName = exports.EventName || (exports.EventName = {}));
var EventProperty;
(function (EventProperty) {
    /** Session properties */
    EventProperty["USER_ID"] = "User ID";
    EventProperty["CUSTOMER_NAME"] = "Customer Name";
    EventProperty["CUSTOMER_CODE"] = "Customer Code";
    EventProperty["SESSION_ID"] = "Session ID";
    EventProperty["BOT_SLUG"] = "Bot Slug";
    EventProperty["CHANNEL"] = "Channel";
    /** Storefront properties */
    EventProperty["CURRENCY"] = "Currency";
    /** Product properties */
    EventProperty["PRODUCT_ID"] = "Product ID";
    EventProperty["PRODUCT_SKU"] = "Product SKU";
    EventProperty["PRODUCT_NAME"] = "Product Name";
    EventProperty["PRODUCT_PRICE"] = "Product Price";
    EventProperty["PRODUCT_TOTAL_PRICE"] = "Product Total Price";
    EventProperty["PRODUCT_CATEGORY"] = "Product Category";
    EventProperty["PRODUCT_NEW_QUANTITY"] = "New Product Quantity";
    /** Order properties */
    EventProperty["ORDER_NOTE"] = "Order Note";
    /** UI properties */
    EventProperty["ACTION_SCREEN"] = "Action Screen";
    /** Search properties */
    EventProperty["SEARCH_TERM"] = "Search Term";
    EventProperty["SEARCH_RESULTS"] = "# of Results";
    EventProperty["SEARCH_TOTAL"] = "Total # of Searches";
    EventProperty["SEARCH_START_TOTAL"] = "# of Search Starts";
    /** Cart properties */
    EventProperty["CART_SIZE"] = "Cart Size";
    EventProperty["CART_VALUE"] = "Cart Value";
    EventProperty["CART_PRODUCT_IDS"] = "Cart Product IDs";
    EventProperty["CART_PRODUCT_SKUS"] = "Cart Product SKUs";
    EventProperty["CART_PRODUCT_NAMES"] = "Cart Product Names";
    EventProperty["CART_PRODUCT_CATEGORIES"] = "Cart Product Categories";
    EventProperty["CUSTOM_NOTE_TEXT"] = "Custom Note Text";
    EventProperty["PRELOADED_CART_TYPE"] = "Pre-loaded Cart Type";
    /** Product Category properties */
    EventProperty["SELECTED_CATEGORY"] = "Selected Category";
})(EventProperty = exports.EventProperty || (exports.EventProperty = {}));
